window.theme = window.theme || {}
theme.Slideshow = (function () {
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused',
  }

  function slideshow(el) {
    this.$slideshow = $(el)
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper)
    this.$pause = this.$wrapper.find('.' + classes.pauseButton)

    let fade = true
    if (this.$slideshow.data('slide-show') > 1) {
      fade = false
    }

    this.settings = {
      accessibility: true,
      slidesToShow: this.$slideshow.data('slide-show'),
      arrows: this.$slideshow.data('arrow'),
      dots: this.$slideshow.data('dots'),
      fade: fade,
      rtl: theme.rtl,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed'),
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            fade: fade,
            dots: this.$slideshow.data('dots-mob'),
          },
        },
      ],
    }

    this.$slideshow.on('beforeChange', beforeChange.bind(this))
    this.$slideshow.on('init', slideshowA11y.bind(this))
    this.$slideshow.slick(this.settings)

    this.$pause.on('click', this.togglePause.bind(this))
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider
    var $list = obj.$list
    var $wrapper = this.$wrapper
    var autoplay = this.settings.autoplay

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live')

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return
      }

      $list.attr('aria-live', 'polite')

      if (autoplay) {
        $slider.slick('slickPause')
      }
    })

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function (evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev')
        }

        if (evt.which === 39) {
          $slider.slick('slickNext')
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find('.slick-active button').focus()
        }
      })
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider
    var $currentSlide = $slider.find('.' + classes.currentSlide)
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    )
  }

  slideshow.prototype.togglePause = function () {
    var slideshowSelector = getSlideshowId(this.$pause)
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused)
      $(slideshowSelector).slick('slickPlay')
    } else {
      this.$pause.addClass(classes.isPaused)
      $(slideshowSelector).slick('slickPause')
    }
  }

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id')
  }

  return slideshow
})()

theme.slideshows = {}

theme.SlideshowSection = (function () {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container))
    var sectionId = $container.attr('data-section-id')
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId)

    $(slideshow).each(function () {
      var $el = $(this)
    })

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow)
  }

  return SlideshowSection
})()

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function () {
      delete theme.slideshows[this.slideshow]
    },

    onBlockSelect: function (evt) {
      var $slideshow = $(this.slideshow)

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      )
      var slideIndex = $slide.data('slick-index')

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause')
    },

    onBlockDeselect: function () {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay')
    },
  }
)
